<header class="header-container" [ngClass]="{'header-auth': !!user}">
  <img [src]="setupService.logo()"
       class="header-logo img-fluid" />
</header>
